import { useEffect } from "react";
import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { getClusterlets } from "../../../../store/constructs/clusterlets/selectors";
import { getNetworks } from "../../../../store/constructs/networks/selectors";
import { getMessages } from "../../../../store/constructs/messages/selectors";
import { getRoutingRules } from "../../../../store/constructs/routing_rules/selectors";
import { getUserTriggers } from "../../../../store/constructs/user_triggers/selectors";
import { clusterletConstructTags } from "../../../../config/common";



export const nameRepetionNotAllowedTags = [
	"clusterlet",
	"external_function",
	"sensor",
	"rrdef",
	"user_trigger",
	"network",
	"analytics",
	"instances",
	"message",
	"profile"
]

const nodeKeysLabel = {
	clusterlet: "Digital Twin",
	external_function: "Delegate",
	sensor: "Physical Object",
	analytics: process.env.REACT_APP_ANALYTICS,
	// infer_engine: "Infer Engine",
	// learn_engine: "Learn Engine",
	// generate_engine: "Generate Engine",

	// profile: 'Profile',
};

export const useKeypress = (key, action) => {
	useEffect(() => {
		function onKeyup(e) {
			if (e.key === key) action();
		}
		window.addEventListener("keyup", onKeyup);
		return () => window.removeEventListener("keyup", onKeyup);
	}, []);
};

const nodeKeys = Object.keys(nodeKeysLabel);

export default { nodeKeys, nodeKeysLabel };

export const initialElements = [];

export const capitalize = (s) => {
	if (typeof s !== "string") return "";
	return s.charAt(0).toUpperCase() + s.slice(1);
};

export const validateLabel = (value, isFromHelpertext = false, checkNameExist, tag) => {

	const startChar = value.charAt(0);
	let startWith = new RegExp(/[A-za-z_]/).test(startChar);
	if (!startWith && !isFromHelpertext) return false;

	const whitespace = new RegExp(/\s/g).test(value);
	if (whitespace && !isFromHelpertext) return false;

	let specialChar = new RegExp(/[!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?]+/).test(value)

	if (tag == 'profile') {
		specialChar = new RegExp(/[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]+/).test(value);
		/**
		 * the name value of profiles are ids of the clusterlets
		 * the start with maybe digits or underscore
		 * hence, giving startWith true always for profiles
		*/
		startWith = true
	}

	if (specialChar && !isFromHelpertext) return false;

	const namePresent = checkNameExist
	if (namePresent === false && !isFromHelpertext) return false;

	if (isFromHelpertext) {
		return {
			startWith,
			whitespace,
			specialChar,
			namePresent
		};
	}
	return true;
};

export const validateNameLabel = (value, isFromHelpertext = false) => {
	const startChar = value.charAt(0);
	const startWith = new RegExp(/[A-za-z_]/).test(startChar);
	if (!startWith && !isFromHelpertext) return false;
	const whitespace = new RegExp(/\s/g).test(value);
	if (whitespace && !isFromHelpertext) return false;
	const specialChar = new RegExp(/[!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?]+/).test(value);
	if (specialChar && !isFromHelpertext) return false;

	if (isFromHelpertext) {
		return {
			startWith,
			whitespace,
			specialChar,
		};
	}

	return true;
};

export const checkNameExist = (value, elements) => {
	// console.log("value and elements", {value,elements})
	if (value === undefined) return false
	const valueInLowerCase = value.toLowerCase()
	const cloneNameExists = elements.find(e => (e.name).toLowerCase() === valueInLowerCase)
	if (cloneNameExists) return true
	else return false
};

export const LabelHelperText = (payload) => {

	const { control, elementTag } = payload

	let elements = [];
	let nameExists = false

	const clusterlets = useSelector(getClusterlets);
	const messages = useSelector(getMessages);
	const networks = useSelector(getNetworks);
	const rrdefs = useSelector(getRoutingRules);
	const userTriggers = useSelector(getUserTriggers);
	if (elementTag === "message") elements = messages;
	if (elementTag === "network") elements = networks;
	if (elementTag === "rrdef") elements = rrdefs;
	if (elementTag === "user_trigger") elements = userTriggers;
	if (clusterletConstructTags.includes(elementTag)) elements = clusterlets


	const value = useWatch({
		control,
		name: "label",
		defaultValue: "Digital_Twin",
	});
	const { title } = control.getValues()
	// console.log("title", {title, elements})

	nameExists = checkNameExist(title, elements)
	// console.log("exists", nameExists)


	const { startWith, whitespace, specialChar } = validateLabel(value, true);

	return (
		<Grid container direction="column">
			{nameExists && <Grid item>
				<Typography color={nameExists ? "error" : ""} variant="subtitle">
					• {elementTag} with the given name exists. Please provide a different name.
				</Typography>
			</Grid>}
			<Grid item>
				<Typography color={!startWith ? "error" : ""} variant="subtitle">
					• The string should start with either a character or _.
				</Typography>
			</Grid>
			<Grid item>
				<Typography color={whitespace ? "error" : ""} variant="subtitle">
					• The string should not contain white spaces.
				</Typography>
			</Grid>
			<Grid item>
				<Typography color={specialChar ? "error" : ""} variant="subtitle">
					• The string should not contain any special characters except _.
				</Typography>
			</Grid>
		</Grid>
	);
};


export const validateBlueprintName = (value) => {

	if (value === "") return "Blueprint name cannot be empty"

	const startChar = value.charAt(0);
	const startWith = new RegExp(/[A-za-z_]/).test(startChar);
	if (!startWith) return "Blueprint name should start with either a character or _";

	const specialChar = new RegExp(/[!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?]+/).test(value);
	if (specialChar) return "Blueprint name should not contain special characters";

	const whitespace = new RegExp(/\s/g).test(value);
	if (whitespace) return "Blueprint name should not contain white spaces";

};

export const checkBlueprintNameExits = (payload) => {

	const { title, blueprintNames } = payload

	const titleInLowerCase = title.toLowerCase()

	let namePresent = false

	blueprintNames.forEach(name => {
		if (name.toLowerCase() === titleInLowerCase) namePresent = "Sorry, the given blueprint name is taken"
	})

	return namePresent
}
